import { useGetOrganizationInfo } from '@/feature/profiles/hooks/organizationAPI';
import { Permission, useHasPermission } from '@/utils/roles';

export const useEfaxAccess = (enabled = true) => {
  const { hasPermission, isLoading: permLoading } = useHasPermission(
    Permission.VIEW_EFAX,
    true,
    { enabled },
  );
  const { data: orgInfo, isLoading: orgLoading } = useGetOrganizationInfo({
    enabled: enabled && hasPermission,
  });
  const canAccess =
    hasPermission && orgInfo?.enableAnonymousRecordFaxSearch === true;

  return {
    canAccess,
    hasPermission,
    isLoading: permLoading || orgLoading,
    orgInfo,
  };
};
